(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');

exports.Z = _default;

/***/ }),

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(46857);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 94208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppWrapperContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86886);
/* harmony import */ var _AppNavBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7486);



function AppWrapperContainer(param) {
    let { children , nav , navBgColor  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        sx: {
            paddingTop: {
                xs: "55px",
                md: "72px"
            }
        },
        children: [
            nav ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppNavBar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                navBgColor: navBgColor
            }) : null,
            children
        ]
    });
}


/***/ }),

/***/ 46857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/AppNavBar.tsx + 1 modules
var AppNavBar = __webpack_require__(7486);
// EXTERNAL MODULE: ./components/AppWrapperContainer.tsx
var AppWrapperContainer = __webpack_require__(94208);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/assets/images/home/notFound.svg
/* harmony default export */ var notFound = ({"src":"/_next/static/media/notFound.6e2edd29.svg","height":440,"width":291});
;// CONCATENATED MODULE: ./pages/404.tsx







function Custom404() {
    const [count, setCount] = (0,react.useState)(5);
    (0,react.useEffect)(()=>{
        goToHome();
        countdown;
    }, []);
    function goToHome() {
        setTimeout(()=>{
            window.location.href = "/";
        }, 5000);
    }
    function goBack() {
        window.history.back();
    }
    const countdown = setInterval(()=>{
        setCount(count - 1);
    }, 1000);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            sx: {
                height: {
                    xs: "100%",
                    md: "100vh"
                },
                background: "linear-gradient(180deg, #E5F2FF 0%, #FFF 100%)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppNavBar/* default */.Z, {
                    navBgColor: "white"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AppWrapperContainer/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            backgroundSize: "cover",
                            display: "grid",
                            placeContent: "center",
                            backgroundRepeat: "no-repeat",
                            padding: "2%",
                            height: "100%",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                width: {
                                    xs: "100%",
                                    md: "80%"
                                },
                                display: "flex",
                                gap: "12px",
                                placeContent: "center",
                                margin: {
                                    xs: 0,
                                    md: "8% auto"
                                },
                                flexDirection: {
                                    xs: "column-reverse",
                                    md: "row"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        flex: "1"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: "40px",
                                                fontWeight: 600,
                                                textAlign: {
                                                    xs: "center",
                                                    md: "left"
                                                },
                                                color: "#393F50"
                                            },
                                            children: "404"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "24px",
                                                    md: "32px"
                                                },
                                                fontWeight: 400,
                                                textAlign: {
                                                    xs: "center",
                                                    md: "left"
                                                },
                                                color: "#393F50"
                                            },
                                            children: "The page you are looking for cannot be found"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            sx: {
                                                fontSize: {
                                                    xs: "16px",
                                                    md: "18px"
                                                },
                                                fontWeight: 400,
                                                marginTop: "4%",
                                                textAlign: {
                                                    xs: "center",
                                                    md: "left"
                                                },
                                                color: "#393F50"
                                            },
                                            children: "We can’t seem to find the page you are looking for. Try going back to previous page or go to the website home."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            sx: {
                                                display: {
                                                    xs: "flex",
                                                    md: "none"
                                                },
                                                gap: "12px",
                                                marginTop: "8%",
                                                paddingBottom: {
                                                    xs: "5%",
                                                    md: "0"
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    sx: {
                                                        flex: {
                                                            xs: "1",
                                                            md: ""
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "outlined",
                                                        fullWidth: true,
                                                        sx: {
                                                            textTransform: "none"
                                                        },
                                                        onClick: goBack,
                                                        children: "Go back"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    sx: {
                                                        flex: {
                                                            xs: "1",
                                                            md: ""
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "contained",
                                                        fullWidth: true,
                                                        sx: {
                                                            textTransform: "none"
                                                        },
                                                        onClick: goToHome,
                                                        children: "Go to home"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            sx: {
                                                display: {
                                                    xs: "none",
                                                    md: "flex"
                                                },
                                                gap: "12px",
                                                marginTop: "8%",
                                                paddingBottom: {
                                                    xs: "5%",
                                                    md: "0"
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "outlined",
                                                        sx: {
                                                            textTransform: "none"
                                                        },
                                                        onClick: goBack,
                                                        children: "Go back"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "contained",
                                                        sx: {
                                                            textTransform: "none"
                                                        },
                                                        onClick: goToHome,
                                                        children: "Go to home"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: {
                                                        xs: "16px",
                                                        md: "16px"
                                                    },
                                                    fontWeight: 400,
                                                    marginTop: "4%",
                                                    textAlign: {
                                                        xs: "center",
                                                        md: "left"
                                                    },
                                                    color: "#393F50"
                                                },
                                                children: [
                                                    "Redirecting you to the website home in",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        style: {
                                                            padding: "6px 12px",
                                                            borderRadius: "50%",
                                                            border: "4px solid #00BF5D",
                                                            borderRight: count == 4 ? "4px solid #fff" : count == 4 || count == 3 || count == 2 || count == 1 ? "4px solid #fff" : "",
                                                            borderBottom: count == 3 ? "4px solid #fff" : count == 3 || count == 2 || count == 1 ? "4px solid #fff" : "",
                                                            borderLeft: count == 2 ? "4px solid #fff" : count == 1 ? "4px solid #fff" : "",
                                                            borderTop: count == 1 ? "4px solid #B2E5B6" : ""
                                                        },
                                                        children: [
                                                            " ",
                                                            count
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        flex: "1",
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            display: "grid",
                                            placeContent: {
                                                xs: "center",
                                                md: "flex-end"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: notFound,
                                            alt: "notFoundimg",
                                            style: {
                                                height: "300px",
                                                width: "300px"
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var _404 = (Custom404);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9194,6886,5675,2093,7538,7486,9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);